<nb-card style="min-height: 30vh; min-width: 50vw">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <h6>Invite Member</h6>
    <nb-icon
      icon="close-outline"
      class="cursor-pointer"
      (click)="ref?.close()"
    ></nb-icon>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loadingUserGroups">
    <div *ngIf="!loadingUserGroups" class="row">
      <app-custom-form-label
        label="Invite via Email"
        [required]="true"
        toolTip="Enter the email of your team members to invite them to join your team."
        [showInfoAsTooltip]="false"
        class="col-xl-5"
      >
      </app-custom-form-label>
      <div class="col-xl-7">
        <div
          class="d-flex align-items-center p-1 invite-user-inputs rounded"
          style="border: 1px solid #8ea6c1"
        >
          <input
            type="text"
            fieldSize="small"
            nbInput
            [formControl]="email"
            placeholder="Enter Email"
            [required]="true"
            style="background-color: #fff; border: none; width: 100%"
            [status]="email.dirty && email.invalid ? 'danger' : 'basic'"
          />
          <nb-select
            [formControl]="userGroup"
            placeholder="Permission"
            size="small"
            style="width: 65%"
            [disabled]="!hasUserGroupReadPermission"
            nbTooltip="Access Denied: Missing User Group Read Permission"
            [nbTooltipDisabled]="hasUserGroupReadPermission"
          >
            <nb-select-label>
              {{ userGroupIdLabelMap[userGroup?.value] }}
            </nb-select-label>
            <nb-option *ngFor="let group of userGroups" [value]="group?.value">
              <app-smart-table-long-string-ellipsis
                [value]="
                  jsonStringify({
                    value: group?.label || 'N/A',
                    truncateLength: 12
                  })
                "
              ></app-smart-table-long-string-ellipsis>
            </nb-option>
          </nb-select>
        </div>
        <div
          *ngIf="email.errors && (email.dirty || email.touched)"
          class="pt-2"
        >
          <label
            class="caption text-danger d-flex align-items-center justify-content-start"
          >
            <nb-icon icon="alert-circle-outline" class="mr-2"></nb-icon>
            <span *ngIf="email.errors.required">Email is required</span>
            <span *ngIf="email.errors.email"
              >Please enter a valid email address.</span
            >
          </label>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <app-rbac-button
      label="Invite"
      class="mr-3"
      status="primary"
      [action]="USER_WRITE"
      [loading]="inviteUserInProgress"
      [disabled]="
        !email?.value?.length ||
        !userGroup?.value?.length ||
        email?.invalid ||
        userGroup?.invalid ||
        inviteUserInProgress
      "
      (onClick)="inviteUser()"
    ></app-rbac-button>
  </nb-card-footer>
</nb-card>
